/**
 * Auth Provider component
 */

import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';
import type { LoginRequest, RegisterRequest } from '../../api/auth';

interface AuthContextType {
  apiKey: string | null;
  accessToken: string | null;
  user: {
    id: string;
    email: string;
    username: string;
    full_name?: string;
    tenant_id?: string;
    is_email_verified: boolean;
  } | null;
  username: string | null;
  isAuthenticated: boolean;
  login: (request: LoginRequest) => Promise<void>;
  register: (request: RegisterRequest) => Promise<any>;
  logout: () => void;
  isValidating?: boolean;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
}

